<template>
  <div class="bg-color-config">
    <color-picker
      v-model:pureColor="pureColor"
      theme="black"
      is-widget
      format="hex8"
      round-history
      picker-type="chrome"
      :debounce="0"
      @update:pure-color="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import { useEditorStore } from '@/store/use-editor-store';
import { ref, watch } from 'vue';
import { ColorInputWithoutInstance } from 'tinycolor2';
import tinycolor from 'tinycolor2';

const editorStore = useEditorStore();
const pureColor = ref<ColorInputWithoutInstance>('#515151');

watch(
  () => editorStore.canvasBgColor,
  () => {
    pureColor.value = editorStore.canvasBgColor;
  },
  {
    immediate: true,
    deep: true
  }
);

const onChange = (val: ColorInputWithoutInstance) => {
  const color = tinycolor(val);
  const hex = color.toHex8().substring(0, 8).toUpperCase();
  editorStore.canvasBgColor = `#${hex}`;
};
</script>

<style scoped lang="less">
.bg-color-config {
  :deep(.vc-colorpicker) {
    background-color: transparent !important;
    input {
      color: white !important;
    }
  }
  :deep(.vc-colorpicker--container) {
    padding-top: 4px;
  }
}
</style>
